import React from 'react';
import PropTypes from 'prop-types';
import I18n from 'utils/I18n';

import { ActionsCheckCircleOnLarge } from '@strava/icons';
import { I18nPrefix } from '../../shared/SubscriberSummary';
import { getSubStatusFlags } from '../../../../helpers/account.helpers';

import styles from './SubscriptionValueProps.styles.scss';

const SubscriptionValueProps = ({ subStatus, isStudent }) => {
  const { isSubscribed, isTrial, isPreview, isCancelled } = getSubStatusFlags(
    subStatus
  );

  const subscriptionType = () => {
    if (isSubscribed || isTrial || isPreview || isStudent) {
      return 'subscribed';
    }
    if (isCancelled) {
      return 'cancelled';
    }
    return 'free';
  };

  const features = [
    {
      header: I18n.t(`${I18nPrefix}.value_props.features.routes`)
    },
    {
      header: I18n.t(`${I18nPrefix}.value_props.features.analysis`)
    },
    {
      header: I18n.t(`${I18nPrefix}.value_props.features.trails`),
      badge: I18n.t('templates.account.subscription_features.trail_badge')
    },
    {
      header: I18n.t(`${I18nPrefix}.value_props.features.leaderboards`)
    }
  ];

  const alsoIncluded = [
    {
      header: I18n.t(`${I18nPrefix}.value_props.features.recover.title`),
      text: I18n.t(`${I18nPrefix}.value_props.features.recover.description`),
      link: 'https://recoverathletics.com/'
    },
    {
      header: I18n.t(`${I18nPrefix}.value_props.features.fatmap.title`),
      text: I18n.t(`${I18nPrefix}.value_props.features.fatmap.description`),
      link: 'https://www.fatmap.com/'
    }
  ];

  const title = I18n.t_html(
    `${I18nPrefix}.value_props.title.${subscriptionType()}`
  );

  const shouldShowLinkToAllFeatures = subscriptionType() !== 'subscribed';

  return (
    <div className={styles.subValueProps}>
      <div className={styles.title}>{title}</div>
      <ul>
        {features.map((feature) => (
          <li className={styles.features} key={feature.header}>
            <div className={styles.icon}>{<ActionsCheckCircleOnLarge />}</div>
            <div className={styles.header}>{feature.header}</div>
            {feature.badge && (
              <span className={styles.badge}>
                {feature.badge.toUpperCase()}
              </span>
            )}
          </li>
        ))}
      </ul>
      <div className={styles.alsoIncluded}>
        {I18n.t_html(`${I18nPrefix}.value_props.also_included`)}
      </div>
      <ul>
        {alsoIncluded.map((feature) => (
          <li className={styles.featuresContainer} key={feature.header}>
            <div className={styles.features}>
              <div className={styles.icon}>{<ActionsCheckCircleOnLarge />}</div>
              <a href={feature.link} target="_blank" rel="noopener noreferrer">
                <div>{feature.header}</div>
              </a>
            </div>
            <div className={styles.text}>{feature.text}</div>
          </li>
        ))}
      </ul>
      {shouldShowLinkToAllFeatures && (
        <a
          href="/subscribe?origin=account-see-all-premium-features"
          target="_blank"
          rel="noopener noreferrer"
          className={styles.seeAllLink}
        >
          {I18n.t(`${I18nPrefix}.value_props.link`)}
        </a>
      )}
    </div>
  );
};

SubscriptionValueProps.propTypes = {
  subStatus: PropTypes.string.isRequired,
  isStudent: PropTypes.bool.isRequired
};

export default SubscriptionValueProps;
